import React, { createContext, useContext, useState, useEffect } from 'react';

const EnvironmentContext = createContext();

export const useEnvironment = () => {
  const context = useContext(EnvironmentContext);
  if (!context) {
    throw new Error('useEnvironment must be used within an EnvironmentProvider');
  }
  return context;
};

export const EnvironmentProvider = ({ children }) => {
  const [environment, setEnvironment] = useState(null);
  const [isUAT, setIsUAT] = useState(false);
  const [isProd, setIsProd] = useState(false);
  const [isDemo, setIsDemo] = useState(false);

  useEffect(() => {
    const env = import.meta.env.VITE_ENVIRONMENT;
    setEnvironment(env);
    setIsUAT(env === 'uat');
    setIsProd(env === 'production');
    setIsDemo(env === 'demo');
  }, []);

  return (
    <EnvironmentContext.Provider value={{ environment, isUAT, isProd, isDemo }}>
      {children}
    </EnvironmentContext.Provider>
  );
};